"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.betaLinks = void 0;
const production_1 = require("./production");
// PHASE: beta
const ORIGIN = 'https://beta-m.place.naver.com';
const MYPLACE_WEB = 'https://beta-m.place.naver.com/my';
const CDN_ORIGIN = 'https://qa-myplace-static.fe.naver.com';
const SMART_PLACE_DOMAIN = 'https://stage-new.smartplace.naver.com';
const PLACE_ORIGIN_FROM_MAP_STAGE = 'https://stage-nmap.place.naver.com';
const BOOKING_GRAPHQL = 'https://stage-release-booking.io.naver.com/graphql';
const BOOKING_WEB_ORIGIN = 'https://stage-release-booking.io.naver.com';
/** https://oss.navercorp.com/Maps/sloop/wiki/Train-End-URLs-스펙/#host */
const TRAIN_TICKET_ORIGIN = 'https://stg-pt.map.naver.com/end-train';
exports.betaLinks = {
    ...production_1.productionLinks,
    BOOKING_GRAPHQL,
    MYPLACE_WEB,
    MYPLACE_API: 'https://beta-api.place.naver.com/my',
    CDN_ORIGIN,
    CDN_ICONS: `${CDN_ORIGIN}/cdn/static/icons`,
    FEDERATION_API_ON_BROWSER: 'https://stg-bff-gateway.place.naver.com',
    FEDERATION_API_ON_NODE: 'https://stg-place-federated-bff.io.naver.com',
    TRAIN_TICKET_CANCEL: `${TRAIN_TICKET_ORIGIN}/bridges/ticket/cancel/done?tNo=`,
    TRAIN_TICKET_DETAIL: `${TRAIN_TICKET_ORIGIN}/bridges/ticket/home?swNo=&sDt=&ssNo=&trPw=`,
    TRAIN_TICKET_RESERVATION: 'https://map.naver.com/p/train',
    TRAIN_TICKET_MY_RESERVATION_LIST: `${TRAIN_TICKET_ORIGIN}/bridges/schedule-board/web/home?ac=ticket&userQuery=where%3Amo_fusion%2Cmenu%3Amap_tts-resercation%22`,
    MYPLACE_REVIEW_FEED: `${MYPLACE_WEB}/:userId/reviewfeed?reviewId=:reviewId`,
    API_URL_ON_BROWSER: 'https://beta-api.place.naver.com/my',
    API_URL_ON_NODE: 'http://profile-api-beta.myplace.svc.ar2.io.navercorp.com/my',
    BOOKING_MY: `${BOOKING_WEB_ORIGIN}/my/bookings?from=myp`,
    BOOKING_MY_COUPONS: `${BOOKING_WEB_ORIGIN}/my/coupons?from=myp`,
    BOOKING_BUSINESS_HOME: `${BOOKING_WEB_ORIGIN}/booking/bizes/:businessId?from=myp`,
    BOOKING_DETAIL: `${BOOKING_WEB_ORIGIN}/my/bookings/:bookingId?from=myp`,
    /** 예약상품 URL - businessTypeId 조회 불가능한 경우 redirection URL (businessTypeId 임의값) */
    BOOKING_ITEM_REDIRECT: `${BOOKING_WEB_ORIGIN}/booking/000/bizes/:businessId/items/:bizItemId?from=myp`,
    /** 예약상품 URL - businessTypeId 조회가능한 경우 사용 */
    BOOKING_ITEM: `${BOOKING_WEB_ORIGIN}/booking/:businessTypeId/bizes/:businessId/items/:bizItemId?from=myp`,
    ORDER_ITEM: `${BOOKING_WEB_ORIGIN}/order/bizes/:businessId/items/:bizItemId?theme=place&from=myp`,
    ORDER_MY: `${BOOKING_WEB_ORIGIN}/my/orders?from=myp`,
    ORDER_DETAIL: `${BOOKING_WEB_ORIGIN}/my/orders/:orderId?from=myp`,
    QUEUE_MY: `${BOOKING_WEB_ORIGIN}/my/queues?from=myp`,
    DIRECTION: 'http://m.map.naver.com/viewer/route.nhn?',
    FILE_API: 'https://beta-files.place.naver.com/my',
    FILE_UPLOAD: 'https://beta-files.place.naver.com/my/upload',
    TRAVEL_HOTEL_REVIEW: `https://stage-hotels.naver.com/hotels/:hotelId/cpReview/myplace`,
    TRAVEL_HOTEL_DETAIL: `https://stage-hotels.naver.com/hotels/:hotelId`,
    TRAVEL_HOTEL_MY: `https://stage-travel.naver.com/my/reviews/me/hotel`,
    TRAVEL_HOTEL_MY_BOOKING: `https://stage-travel.naver.com/my/bookings/hotels`,
    MY_HOME: `${ORIGIN}/my`,
    MAP_APP_LINK: 'https://m.map.naver.com/appLink.naver',
    MAP_STATIC: 'https://simg.pstatic.net/static.map/v2/map/staticmap.bin?',
    // MAP_USEFUL_TIPS: 'https://stg-pt.map.naver.com/end-quick-path/bridges/useful-tips/bookmark',
    MAP_USEFUL_TIPS: 'https://pt.map.naver.com/end-quick-path/bridges/useful-tips/bookmark',
    MY_DATA: 'https://new-beta2-m.pay.naver.com/mydata',
    NAVER_APP: 'https://m.naver.com/naverapp/',
    OPEN_MAIN: 'https://openmain.pstatic.net/js/openmain.js',
    ORIGIN,
    PANORAMA_THUMBNAIL: 'https://stg-panorama.map.naver.com/api/v2/thumbnail',
    PC_MAP: 'https://stg-v5.map.naver.com/v5',
    PHOTO_DETAIL: 'https://stage-m.place.naver.com/place/:id/photo',
    PAY_MY_INCOME_EXPENSE: 'https://new-beta2-m.pay.naver.com/pfms/statements',
    PLACE_DETAIL: 'https://stage-m.place.naver.com/place/:placeId',
    PLACE_DETAIL_FROM_MAP: `${PLACE_ORIGIN_FROM_MAP_STAGE}/place/:placeId?from=my`,
    PLACE_DETAIL_REVIEW_TAB: `https://stage-m.place.naver.com/place/:placeId/review/visitor`,
    REGISTER_NEW_PLACE: `${SMART_PLACE_DOMAIN}/places/registration?referer=myplace&redirectURL=`,
    SMART_PLACE_DOMAIN,
    TERMS: 'https://m.place.naver.com/my/terms',
    YEAR_END_2022: `${ORIGIN}/my/year-end/2022`,
    NAVER_CLIP: 'https://m.naver.com/shorts/?',
    MAP_LIST_ALL: `https://stage-pages.map.naver.com/save-pages/web/all-list`,
    MAP_LIST_AROUND: 'https://stage-pages.map.naver.com/save-pages/web/around-list',
    MAP_LIST_DETAIL: `https://stage-pages.map.naver.com/save-pages/web/detail-list/:shareId`,
};
